<div class="wrapper">
    <app-toolbar isExtendedToolbar="true"></app-toolbar>
    <div class="row center-xs">
        <div class="col-xs-12">
            <ng-content select="[content]"></ng-content>
        </div>
    </div>
    <app-footer></app-footer>
</div>
